import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _77b7aa91 = () => interopDefault(import('../pages/announcement/index.vue' /* webpackChunkName: "pages/announcement/index" */))
const _b9b9d9ae = () => interopDefault(import('../pages/home/index.vue' /* webpackChunkName: "pages/home/index" */))
const _e4b33488 = () => interopDefault(import('../pages/indexOld.vue' /* webpackChunkName: "pages/indexOld" */))
const _0ea9c81d = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _648e9596 = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _317e1341 = () => interopDefault(import('../pages/service/index.vue' /* webpackChunkName: "pages/service/index" */))
const _24758616 = () => interopDefault(import('../pages/submission/index.vue' /* webpackChunkName: "pages/submission/index" */))
const _499205e8 = () => interopDefault(import('../pages/auth/check.vue' /* webpackChunkName: "pages/auth/check" */))
const _1c1de38b = () => interopDefault(import('../pages/auth/checkforgot.vue' /* webpackChunkName: "pages/auth/checkforgot" */))
const _10013a1a = () => interopDefault(import('../pages/auth/forgot.vue' /* webpackChunkName: "pages/auth/forgot" */))
const _6954106e = () => interopDefault(import('../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _277f2073 = () => interopDefault(import('../pages/auth/register.vue' /* webpackChunkName: "pages/auth/register" */))
const _1a980d3a = () => interopDefault(import('../pages/auth/success.vue' /* webpackChunkName: "pages/auth/success" */))
const _c547e274 = () => interopDefault(import('../pages/auth/successforgot.vue' /* webpackChunkName: "pages/auth/successforgot" */))
const _6a60aeac = () => interopDefault(import('../pages/auth/reset/_slug.vue' /* webpackChunkName: "pages/auth/reset/_slug" */))
const _6c378e34 = () => interopDefault(import('../pages/auth/verification/_slug.vue' /* webpackChunkName: "pages/auth/verification/_slug" */))
const _0d0b1b97 = () => interopDefault(import('../pages/auth/verification/_slugInject.vue' /* webpackChunkName: "pages/auth/verification/_slugInject" */))
const _150fbc11 = () => interopDefault(import('../pages/auth/verification/_slugOld.vue' /* webpackChunkName: "pages/auth/verification/_slugOld" */))
const _600b2192 = () => interopDefault(import('../pages/progress/akl/_id.vue' /* webpackChunkName: "pages/progress/akl/_id" */))
const _1760deda = () => interopDefault(import('../pages/progress/akm/_id.vue' /* webpackChunkName: "pages/progress/akm/_id" */))
const _2d13145a = () => interopDefault(import('../pages/progress/kia/_id.vue' /* webpackChunkName: "pages/progress/kia/_id" */))
const _0a8c4394 = () => interopDefault(import('../pages/progress/kk/_id.vue' /* webpackChunkName: "pages/progress/kk/_id" */))
const _18a0d337 = () => interopDefault(import('../pages/progress/ktp/_id.vue' /* webpackChunkName: "pages/progress/ktp/_id" */))
const _51012138 = () => interopDefault(import('../pages/progress/rkm/_id.vue' /* webpackChunkName: "pages/progress/rkm/_id" */))
const _35fc3b1c = () => interopDefault(import('../pages/progress/skd/_id.vue' /* webpackChunkName: "pages/progress/skd/_id" */))
const _29316f28 = () => interopDefault(import('../pages/progress/skp/_id.vue' /* webpackChunkName: "pages/progress/skp/_id" */))
const _2534d639 = () => interopDefault(import('../pages/progress/upd/_id.vue' /* webpackChunkName: "pages/progress/upd/_id" */))
const _5f552dc5 = () => interopDefault(import('../pages/news/_id.vue' /* webpackChunkName: "pages/news/_id" */))
const _a8a1c3ba = () => interopDefault(import('../pages/product/_id.vue' /* webpackChunkName: "pages/product/_id" */))
const _eb8231ca = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/announcement",
    component: _77b7aa91,
    name: "announcement"
  }, {
    path: "/home",
    component: _b9b9d9ae,
    name: "home"
  }, {
    path: "/indexOld",
    component: _e4b33488,
    name: "indexOld"
  }, {
    path: "/news",
    component: _0ea9c81d,
    name: "news"
  }, {
    path: "/profile",
    component: _648e9596,
    name: "profile"
  }, {
    path: "/service",
    component: _317e1341,
    name: "service"
  }, {
    path: "/submission",
    component: _24758616,
    name: "submission"
  }, {
    path: "/auth/check",
    component: _499205e8,
    name: "auth-check"
  }, {
    path: "/auth/checkforgot",
    component: _1c1de38b,
    name: "auth-checkforgot"
  }, {
    path: "/auth/forgot",
    component: _10013a1a,
    name: "auth-forgot"
  }, {
    path: "/auth/login",
    component: _6954106e,
    name: "auth-login"
  }, {
    path: "/auth/register",
    component: _277f2073,
    name: "auth-register"
  }, {
    path: "/auth/success",
    component: _1a980d3a,
    name: "auth-success"
  }, {
    path: "/auth/successforgot",
    component: _c547e274,
    name: "auth-successforgot"
  }, {
    path: "/auth/reset/:slug?",
    component: _6a60aeac,
    name: "auth-reset-slug"
  }, {
    path: "/auth/verification/:slug?",
    component: _6c378e34,
    name: "auth-verification-slug"
  }, {
    path: "/auth/verification/:slugInject?",
    component: _0d0b1b97,
    name: "auth-verification-slugInject"
  }, {
    path: "/auth/verification/:slugOld?",
    component: _150fbc11,
    name: "auth-verification-slugOld"
  }, {
    path: "/progress/akl/:id?",
    component: _600b2192,
    name: "progress-akl-id"
  }, {
    path: "/progress/akm/:id?",
    component: _1760deda,
    name: "progress-akm-id"
  }, {
    path: "/progress/kia/:id?",
    component: _2d13145a,
    name: "progress-kia-id"
  }, {
    path: "/progress/kk/:id?",
    component: _0a8c4394,
    name: "progress-kk-id"
  }, {
    path: "/progress/ktp/:id?",
    component: _18a0d337,
    name: "progress-ktp-id"
  }, {
    path: "/progress/rkm/:id?",
    component: _51012138,
    name: "progress-rkm-id"
  }, {
    path: "/progress/skd/:id?",
    component: _35fc3b1c,
    name: "progress-skd-id"
  }, {
    path: "/progress/skp/:id?",
    component: _29316f28,
    name: "progress-skp-id"
  }, {
    path: "/progress/upd/:id?",
    component: _2534d639,
    name: "progress-upd-id"
  }, {
    path: "/news/:id",
    component: _5f552dc5,
    name: "news-id"
  }, {
    path: "/product/:id?",
    component: _a8a1c3ba,
    name: "product-id"
  }, {
    path: "/",
    component: _eb8231ca,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
